import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from 'pages/App/App';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as serviceWorker from './serviceWorker';
import env from 'consts/env';
import { PostHogProvider } from 'posthog-js/react';

if (env.BUILD_ENV === 'production') {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    integrations: [new BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
}

if ((module as any).hot && process.env.NODE_ENV !== 'production') {
  (module as any).hot.accept();
}

// eslint-disable-next-line react/no-deprecated
const container = document.getElementById('root') || document.body;
const root = createRoot(container);
root.render(
  <PostHogProvider
    apiKey={env.POSTHOG_KEY as string}
    options={{
      api_host: env.POSTHOG_HOST,
      debug: process.env.NODE_ENV === 'development'
    }}
  >
    <App />
  </PostHogProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
